import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { bonuses } from '../../data/bonuses';
import { padNumber } from '../../utils/format';
export function Bonuses() {
  return <section id="bonuses" aria-labelledby="bonuses-title" className="border-t border-line bg-mint py-20 text-ink lg:py-24" data-id="element-29" data-mp="1nan0e5qaye35">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-30" data-mp="1s7wnheq7ydnt">
        <SectionHeading id="bonuses-title" tone="light" eyebrow="5 bonuses included" lead="Plus 5" highlight="teaching resources" intro="Five practical resources to complement your school year of flag football. All are included in the $27 launch offer." data-id="element-31" data-mp="1dbxl8kpsj7ql" />

        <ul className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-32" data-mp="19bnbqy2shz6z">
          {bonuses.map((bonus, index) => <li key={bonus.name} className={`flex flex-col overflow-hidden rounded-xl border border-line bg-white shadow-[0_16px_32px_-26px_rgba(58,14,8,0.4)] ${index === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-12px)]' : ''}`} data-id="element-33" data-mp="2yr3bxnyqkakq" data-mpi={index}>
              <div className="bg-cream" data-id="element-34" data-mp="pr9oy09c9o2p">
                <img src={bonus.image} alt={`Cover of ${bonus.name}`} loading="lazy" width={1024} height={1024} className="block aspect-square h-auto w-full object-cover" data-id="element-35" data-mp="pq82kzmvhf5o" />
              </div>
              <div className="flex-1 border-t border-line p-6 sm:p-7" data-id="element-36" data-mp="3p7zcmjepb5s2">
                <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-gold-dark" data-id="element-37" data-mp="711q3uco9jsb">Bonus {padNumber(index + 1)}</p>
                <h3 className="mt-2 font-display text-[28px] font-bold uppercase leading-[1.02] sm:text-[30px]" data-id="element-38" data-mp="2041ayx5prhu">{bonus.name}</h3>
                <p className="mt-2 text-base leading-relaxed text-body" data-id="element-39" data-mp="1ihrs11a2bpg4">{bonus.benefit}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-40" data-mp="1lgi81yqthge0">
          <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-41" data-mp="1ljw6wx09v7gp">
            See the complete kit
          </CtaButton>
        </div>
      </div>
    </section>;
}